import gql from "graphql-tag";

export default gql`
  mutation DestroyPost($postId: ObjectID!) {
    destroyPost(postId: $postId)
  }
`;
